export default {
  blog: () => import("/app/layouts/blog.vue"),
  coming: () => import("/app/layouts/coming.vue"),
  default: () => import("/app/layouts/default.vue")
}